import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Coupon = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1213 6.00004L15 8.12136L12.8787 6.00004H3V8.10254C4.34465 8.88026 5.25 10.3332 5.25 12C5.25 13.6668 4.34465 15.1198 3 15.8975V18H12.8787L15 15.8787L17.1213 18H21V6.00004L17.1213 6.00004ZM3 4.50004H13.5L15 6.00004L16.5 4.50004H21C21.8284 4.50004 22.5 5.17161 22.5 6.00004V18C22.5 18.8285 21.8284 19.5 21 19.5H16.5L15 18L13.5 19.5H3C2.17157 19.5 1.5 18.8285 1.5 18V14.9055C2.79392 14.5725 3.75 13.3979 3.75 12C3.75 10.6022 2.79392 9.42758 1.5 9.09455V6.00004C1.5 5.17161 2.17157 4.50004 3 4.50004ZM14.25 8.71879V10.0313H15.75V8.71879H14.25ZM14.25 13.9688V15.2813H15.75V13.9688H14.25ZM14.25 11.3438V12.6563H15.75V11.3438H14.25Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
    </svg>
  );
};

export default Coupon;
